import React, { createContext, useContext, useState, useEffect } from 'react';
import * as settingsAPI from '../services/operations/settingsAPI';

const SettingsContext = createContext();

export const SettingsProvider = ({ children }) => {
    const [settings, setSettings] = useState(null);
    const [loading, setLoading] = useState(true);

    const fetchSettings = async () => {
        try {
            const res = await settingsAPI.getSettings();
            if (res && res.success) {
                setSettings(res.settings);
            }
        } catch (err) {
            console.error('Error fetching settings:', err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchSettings();
    }, []);

    const updateMaintenanceMode = async (status) => {
        try {
            const res = await settingsAPI.updateSettings({ maintenanceMode: status });
            if (res && res.success) {
                setSettings(res.settings);
                return true;
            }
        } catch (err) {
            console.error('Error updating maintenance mode:', err);
        }
        return false;
    };

    return (
        <SettingsContext.Provider value={{ settings, loading, fetchSettings, updateMaintenanceMode }}>
            {children}
        </SettingsContext.Provider>
    );
};

export const useSettings = () => useContext(SettingsContext);
